import _ from "lodash";
import {COLOR_LIST} from "../../common/constants/color.constant";
import {TONES_LIST} from "../../content/constants/blog.constant";
import {FIT_TYPE_LIST, LOGO_POSITION_OPTIONS_LIST} from "../../shopify/constants/shopify.constant";

export const SAVE_DESIGN_TIME_DELAY = 2000;
export const DOWNLOAD_DESIGN_VARIANT_TIME_DELAY = 5000;
export const DOWNLOAD_MULTI_IMAGE_TIME_DELAY = 1000;
export const SEARCH_PRODUCTS_TIME_DELAY = 10;
export const DESIGN_IMAGES_PATH = 'design-images';
export const QUOTE_TEMPLATE_IMAGES_PATH = 'quote-template-images';
export const THUMB_PREFIX = "thumb_";

export const STAGE_ZOOM_STEP = 0.025;
export const BLOCK_SNAP_SIZE = 1;
export const GUIDELINE_OFFSET = 1;

export const DESIGN_DASHBOARD_TABS_LIST = [
    {key: 'designs', label: 'Designs'},
    {key: 'design-variants', label: 'Design Variants'},
];

// export const DEFAULT_DESIGN_DASHBOARD_TAB = {key: 'design-variants', label: 'Design Variants'};
export const DEFAULT_DESIGN_DASHBOARD_TAB = {key: 'designs', label: 'Designs'};

export const DESIGN_EDITOR_TABS_LIST = [
    {key: 'variants', label: 'Variants'},
    /*{key: 'editor', label: 'Designer'},*/
    {key: 'parent-product', label: 'Parent Product'},
];

export const DEFAULT_DESIGN_EDITOR_TAB = {key: 'variants', label: 'Variants'};
export const DESIGN_EDITOR_TAB = {key: 'editor', label: 'Editor'}

export const EDITOR_DETAIL_TABS_LIST = [
    {key: 'product-colors', label: 'Product Colors'},
    {key: 'quote-templates', label: 'Quote Templates'},
];

export const DEFAULT_EDITOR_DETAIL_TAB = {key: 'product-colors', label: 'Product Colors'};

export const PUBLISHER_TABS_LIST = [
    {key: 'design-summary', label: 'Design Summary'},
    {key: 'variants', label: 'Variants'},
    {key: 'parent-product', label: 'Parent Product'},
    {key: 'variant-images', label: 'Variant Images'},
    {key: 'design-meta-description', label: 'Design Meta Description'},
];

export const DEFAULT_PUBLISHER_TAB = {key: 'design-summary', label: 'Design Summary'};

export const ADD_MULTIPLE_DESIGNS_TABS_LIST = [
    {key: 'designs', label: 'Designs'},
    {key: 'parent-product', label: 'Parent Product'},
];

export const DEFAULT_ADD_MULTIPLE_DESIGNS_TAB = {key: 'designs', label: 'Designs'};

export const DESIGN_KEY_PREFIX = {
    VARIANT: 'variant',
    TEXT: 'text',
    IMAGE: 'image',
    SHAPE: 'shape',
    BATCH: 'batch',
};

export const EDITOR_SETTING_TABS_LIST = [
    {key: 'settings', label: 'Settings'},
    {key: 'images', label: 'Images'},
    {key: 'shapes', label: 'Shapes'},
    {key: 'layers', label: 'Layers'},
    {key: 'tags', label: 'Tags'},
];

export const DESIGN_VARIANT_STATUS = {
    IN_DESIGN: 'in-design',
    READY_TO_PUBLISH: 'ready-to-publish',
    PUBLISHED: 'published',
};

export const DEFAULT_EDITOR_SETTING_TAB = {key: 'settings', label: 'Settings'};

export const EDITOR_TEXT_TABS_LIST = [
    {key: 'overview', label: 'Overview'},
    {key: 'font-text', label: 'Font, Text & Color'},
    /*{key: 'stroke-shadow', label: 'Stroke & Shadow'},*/
];

export const DEFAULT_EDITOR_TEXT_TAB = {key: 'overview', label: 'Overview'};

export const TEXT_TABS_LIST = [
    {key: 'font-text', label: 'Font & Text'},
    {key: 'stroke-shadow', label: 'Stroke & Shadow'},
];

export const DEFAULT_TEXT_TAB = {key: 'font-text', label: 'Font & Text'};

export const DEFAULT_SETTINGS = {
    strokeWidth: 50,
    strokeHexCode: '#525252',
    shadowBlur: 0,
    colorKey: 'teal',
    fontSize: 500,
    shadowOffsetX: 50,
    colorCodeKey: 400,
    fill: '#2DD4BF',
    strokeColorCodeKey: 600,
    shadowColorKey: 'neutral',
    shadowColorCodeKey: 300,
    stroke: '#525252',
    strokeColorKey: 'neutral',
    shadowOffsetY: 50,
    lineJoin: 'round',
    shadowColor: '#D4D4D4',
    hexCode: '#2DD4BF',
    fontFamily: 'Keshia',
    fillAfterStrokeEnabled: true,
    width: 1000,
    height: 1000,
    align: 'center',
    textBaseline: 'middle',
    background: {colorType: 'solid'}
}

export const DESIGN_VARIANT_STATUS_LIST = [
    {key: 'in-design', label: 'In Design', color: 'pill-gray'},
    {key: 'ready-to-publish', label: 'Ready To Publish', color: 'pill-green'},
    {key: 'published', label: 'Published', hideOption: true, color: 'pill-purple'},
];

export const DEFAULT_DESIGN_VARIANT_STATUS = {key: 'in-design', label: 'In Design', color: 'pill-gray'};

export const DESIGN_VARIANT_FIELD_LIST = [
    {attribute: 'name', label: 'Name'},
    {attribute: 'description', label: 'Description'},
];

export const DESIGN_FIELD_LIST = [
    {attribute: 'name', label: 'Name'},
    /*{attribute: 'description', label: 'Description'},
    {attribute: 'podName', label: 'POD Name'},
    {attribute: 'productType', label: 'Product Type'},
    {attribute: 'category', label: 'Category'},*/
    {attribute: 'parent', label: 'Parent Product'},
    {attribute: 'themeName', label: 'Theme'},
    {attribute: 'variants', label: 'Variants'},
];

export const FLIP_DIRECTION_LIST = [
    {key: 'horizontal', label: 'Horizontal'},
    {key: 'vertical', label: 'Vertical'},
];

export const FLIP_DIRECTION_KEY = {
    HORIZONTAL: 'horizontal',
    VERTICAL: 'vertical',
};

export const ALIGN_OPTIONS_LIST = [
    {key: 'left', label: 'Left'},
    {key: 'center', label: 'Center'},
    {key: 'right', label: 'Right'},
    {key: 'justify', label: 'Justify'},
];

export const TEXT_BASELINE_OPTIONS_LIST = [
    {key: 'top', label: 'Top'},
    {key: 'middle', label: 'Middle'},
    {key: 'bottom', label: 'Bottom'},
    {key: 'alphabetic', label: 'Alphabetic'},
    {key: 'hanging', label: 'Hanging'},
];

export const POSITION_OPTIONS_LIST = [
    {
        key: 'center-top',
        label: 'Center Top'
    },
    {
        key: 'center-center',
        label: 'Center Center'
    },
    {
        key: 'center-bottom',
        label: 'Center Bottom'
    },
];


export const TEXT_PATH_FIELD_LIST = [
    {attribute: 'radius', label: 'Radius', type: 'number', readOnly: false, group: 'text-path'},
    {attribute: 'letterSpacing', label: 'Letter Spacing', type: 'number', readOnly: false, group: 'text-path'},
    {attribute: 'startAngle', label: 'Start Angle', type: 'number', readOnly: false, group: 'text-path'},
    {attribute: 'sweepAngle', label: 'Sweep Angle', type: 'number', readOnly: false, group: 'text-path'},
    {
        attribute: 'align',
        label: 'Align',
        type: 'select',
        readOnly: false,
        group: 'text-path',
        options: ALIGN_OPTIONS_LIST,
        default: 'center'
    },
    {
        attribute: 'textBaseline',
        label: 'Text Baseline',
        type: 'select',
        readOnly: false,
        group: 'text-path',
        options: TEXT_BASELINE_OPTIONS_LIST,
        default: 'middle'
    },
];


export const TEXT_POSITION_FIELD_LIST = [
    {
        attribute: 'offsetXPercentage',
        label: 'Offset X (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'offsetYPercentage',
        label: 'Offset Y (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'positionType',
        label: 'Position',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: LOGO_POSITION_OPTIONS_LIST,
        default: 'bottom-center',
    }
];

export const LINE_JOIN_OPTIONS_LIST = [
    {key: 'miter', label: 'Miter'},
    {key: 'round', label: 'Round'},
    {key: 'bevel', label: 'Bevel'},
];

export const LINE_CAP_OPTIONS_LIST = [
    {key: 'butt', label: 'Butt'},
    {key: 'round', label: 'Round'},
    {key: 'square', label: 'Square'},
];

export const RECTANGLE_FIELD_LIST = [
    {attribute: 'width', label: 'Width', type: 'number', readOnly: false, group: 'dimension', default: 200},
    {attribute: 'height', label: 'Height', type: 'number', readOnly: false, group: 'dimension', default: 100},
    {
        attribute: 'lineJoin',
        label: 'Line Join',
        type: 'select',
        readOnly: false,
        group: 'line',
        default: 'miter',
        options: LINE_JOIN_OPTIONS_LIST,
    },
];

export const SHAPES_LIST = [
    {key: 'rectangle', label: 'Rectangle', fields: RECTANGLE_FIELD_LIST},
];

export const DEFAULT_RECTANGLE = {
    strokeWidth: 50,
    strokeHexCode: '#525252',
    shadowBlur: 0,
    colorKey: 'teal',
    shadowOffsetX: 0,
    colorCodeKey: 400,
    fill: '#2DD4BF',
    strokeColorCodeKey: 600,
    shadowColorKey: 'neutral',
    shadowColorCodeKey: 300,
    stroke: '#525252',
    strokeColorKey: 'neutral',
    shadowOffsetY: 0,
    lineJoin: 'round',
    shadowColor: '#D4D4D4',
    hexCode: '#2DD4BF',
    fillAfterStrokeEnabled: true,
    width: 1000,
    height: 1000,
    x: 200,
    y: 200
}

export const OPACITY_PERCENTAGE_LIST = [
    {key: 10, label: '10 %'},
    {key: 20, label: '20 %'},
    {key: 30, label: '30 %'},
    {key: 40, label: '40 %'},
    {key: 50, label: '50 %'},
    {key: 60, label: '60 %'},
    {key: 70, label: '70 %'},
    {key: 80, label: '80 %'},
    {key: 90, label: '90 %'},
    {key: 100, label: '100 %'},
];

export const PAGE_LIMIT_LIST = [
    {key: 0, label: 'All'},
    {key: 10, label: '10'},
    {key: 20, label: '20'},
    {key: 30, label: '30'},
    {key: 40, label: '40'},
    {key: 50, label: '50'},
    {key: 60, label: '60'},
    {key: 70, label: '70'},
    {key: 80, label: '80'},
    {key: 90, label: '90'},
    {key: 100, label: '100'},
];

export const REPEAT_IMAGE_FIELD_LIST = [
    {attribute: 'size', label: 'Size (%)', type: 'number', readOnly: false, group: 'dimension'},
    {
        attribute: 'opacity',
        label: 'Template Opacity (%)',
        type: 'select',
        readOnly: false,
        group: 'dimension',
        options: OPACITY_PERCENTAGE_LIST,
        default: 50
    },
    {
        attribute: 'fillPatternOffsetXPercentage',
        label: 'Fill Pattern Offset X (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fillPatternOffsetYPercentage',
        label: 'Fill Pattern Offset Y (%)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fillPatternOffsetXValue',
        label: 'Fill Pattern Offset X (Value)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fillPatternOffsetYValue',
        label: 'Fill Pattern Offset Y (Value)',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
    {
        attribute: 'fillPatternRotation',
        label: 'Fill Pattern Rotation',
        type: 'number',
        readOnly: false,
        group: 'dimension',
        default: 0
    },
];

export const TEMPLATE_IMAGE_FIELD_LIST = [
    {attribute: 'opacity', label: 'Opacity', type: 'number', readOnly: false, group: 'template', default: 100},
];

export const PAGINATION_FIELD_LIST = [
    {
        attribute: 'limit',
        label: 'Limit',
        type: 'select',
        readOnly: false,
        group: 'pagination',
        options: PAGE_LIMIT_LIST,
        default: '10'
    },
];

export const COLOR_TYPE_LIST = [
    {key: 'solid', label: 'Solid'},
    {key: 'linear', label: 'Linear Gradient'},
    {key: 'radial', label: 'Radial Gradient'},
];

export const COLOR_STOP_LIST = [
    {key: '10', label: '0'},
    {key: '20', label: '0.25'},
    {key: '30', label: '0.5'},
    {key: '40', label: '0.75'},
    {key: '50', label: '1'},
];

export const COLOR_FIELD_LIST = [
    {
        attribute: 'colorType',
        label: 'Color Type',
        type: 'select',
        readOnly: false,
        group: 'color',
        options: COLOR_TYPE_LIST,
        default: 'solid',
    },
];

export const GRADIENT_POSITION_OPTIONS_LIST = [
    {
        key: 'left-top',
        label: 'Left Top',
        exclude: ['left-top', 'left-center', 'left-bottom', 'center-top', 'right-top']
    },
    {key: 'left-center', label: 'Left Center', exclude: ['left-top', 'left-center', 'left-bottom']},
    {
        key: 'left-bottom',
        label: 'Left Bottom',
        exclude: ['left-top', 'left-center', 'left-bottom', 'center-bottom', 'right-bottom']
    },
    {
        key: 'right-top',
        label: 'Right Top',
        exclude: ['right-top', 'right-center', 'right-bottom', 'center-top', 'left-top']
    },
    {
        key: 'right-center',
        label: 'Right Center',
        exclude: ['right-top', 'right-center', 'right-bottom']
    },
    {
        key: 'right-bottom',
        label: 'Right Bottom',
        exclude: ['right-top', 'right-center', 'right-bottom', 'center-bottom', 'left-bottom']
    },
    {key: 'center-top', label: 'Center Top', exclude: ['center-top', 'right-top', 'left-top']},
    {key: 'center-center', label: 'Center Center', exclude: ['center-top', 'center-center', 'center-bottom']},
    {
        key: 'center-bottom',
        label: 'Center Bottom',
        exclude: ['center-bottom', 'right-bottom', 'left-bottom', 'center-center']
    },
];

export const GRADIENT_POSITION_FIELD_LIST = [
    {
        attribute: 'startPoint',
        label: 'Start Point',
        type: 'select',
        readOnly: false,
        group: 'position',
        options: GRADIENT_POSITION_OPTIONS_LIST,
        default: 'center-top',
    },
    {
        attribute: 'endPoint',
        label: 'End Point',
        type: 'select',
        readOnly: false,
        group: 'position',
        options: GRADIENT_POSITION_OPTIONS_LIST,
        default: 'center-bottom',
    },
];

export const RADIAL_GRADIENT_RADIUS_FIELD_LIST = [
    {
        attribute: 'startRadius',
        label: 'Start Radius %',
        type: 'number',
        readOnly: false,
        group: 'radius',
        default: 25,
    },
    {
        attribute: 'endRadius',
        label: 'End Radius %',
        type: 'number',
        readOnly: false,
        group: 'radius',
        default: 50,
    },
];

export const MULTI_VARIANT_DESIGNER_TABS_LIST = [
    {key: 'images', label: 'Images'},
    {key: 'settings', label: 'Settings'},
];

export const DEFAULT_MULTI_VARIANT_DESIGNER_TAB = {key: 'images', label: 'Images'};

export const DEFAULT_MULTI_PRODUCTS_DESIGNER_TAB = {key: 'images', label: 'Images'};
export const MULTI_PRODUCTS_DESIGNER_TABS_LIST = [
    {key: 'images', label: 'Images'},
    {key: 'parent-products', label: 'Parent Products'},
    {key: 'products-designer', label: 'Products Designer'},
];

export const DEFAULT_MULTI_PRODUCTS_SETTINGS: any = {
    batchKey: 1,
    images: [],
    designVariants: [],
    background: {
        backgroundColor: "",
        backgroundColorCodeKey: "",
        backgroundColorKey: "",
        colorType: "solid"
    },
    noText: true,
    isRepeatImage: false,
    isBackgroundImage: true,
    size: 100,
    initialSize: 0,
    fillPatternOffsetXPercentage: 0,
    fillPatternOffsetYPercentage: 0,
    fillPatternRotation: 0,
    // fillPatternRepeat: 'repeat',
    fillPatternRepeat: 'no-repeat'
}

export const DESIGN_META_DETAIL_FIELD_LIST = [
    {
        attribute: 'descriptionInput',
        label: 'Meta Description Input',
        type: 'text-area',
        hideInList: true,
        group: 'meta',
        rows: 25,
        class: 'meta-description-list-container'
    },
];

export const DESIGN_VARIANT_FIELDS_LIST = [
    {attribute: "label", label: "Variant Label", cssClass: 'text-left'},
    {attribute: "status", label: "Status", cssClass: 'text-center'},
];

export const DESIGN_CONTENT_INPUT_FIELDS = [
    {
        attribute: "toneOfVoice",
        label: "Tone Of Voice",
        type: 'select',
        readOnly: false,
        group: 'meta',
        options: TONES_LIST,
        default: 'Conversational',
        cssClass: 'w-1/4'
    },
    {attribute: 'count', label: 'Count', type: 'number', readOnly: false, group: 'meta', cssClass: 'w-48'},
];


export const MULTI_PRODUCT_DESIGNER_KEYS = {
    COMMON_DETAIL: 'multi-product-designer.common-detail',
};
